import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import Label from './Label';
import RowIcon from './RowIcons';
import { selectVehiculo } from '../../redux/actions/Vehiculo';
import { changeStepForm, STEPS } from '../../redux/actions/PasosFormulario';
import { checkObligatorio } from '../../redux/actions/Coberturas';


let RowVehiculo = ({ categoria, vehiculo, selectVehiculo, stepFoward, checkObligatorio }) => {

    const coberturas = useSelector(state => state.coberturas);
    const [idTransmision, setTranmision] = useState(vehiculo?.Tarifario[0].IdTransmision);
    const { Dias } = useSelector(state => state.reservacion);
    const { Cambio } = useSelector(state => state.moneda);

    return (
        <>
            <div id={vehiculo.Id} className="row" style={{ marginTop: "20px" }}>
                <div className="col-lg-3">
                    <img src={`${((vehiculo.EsLocal === 'Y') ? `${process.env.PUBLIC_URL}/images/` : ``)}${vehiculo.ImagenURL}`} className="img-row" alt="..." />
                </div>
                <div className="col-lg-6">
                    <div className="row">
                        <div className="col-md-12">
                            <h3 className="cursive">{vehiculo.Nombre}</h3>
                            <div className="input-group mb-2">
                                <Label name="TRANSMISIÓN" />
                                <select onChange={event => { setTranmision(event.target.value) }}>
                                    {
                                        vehiculo.Tarifario.map((tr) =>
                                            <option key={tr.IdTransmision} value={tr.IdTransmision}>{tr.Transmision.Nombre}</option>
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <RowIcon icons={vehiculo.IconosInformacion} />
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 price">
                    <div className="row">
                        <div className="col-12">
                            <p>Tarifa base:</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div>
                                <p>
                                    Q {Number(
                                        (Dias < 7) ? vehiculo.Tarifario.find(w => w.Transmision.Id === idTransmision)?.PrecioDia :
                                            (Dias < 30) ? vehiculo.Tarifario.find(w => w.Transmision.Id === idTransmision)?.PrecioSemana :
                                                vehiculo.Tarifario.find(w => w.Transmision.Id === idTransmision)?.PrecioMes
                                    ).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} por día
                                </p>
                            </div>
                            <div>
                                <p>
                                    $ {Number(
                                        (Dias < 7) ? (vehiculo.Tarifario.find(w => w.Transmision.Id === idTransmision)?.PrecioDia / Cambio) :
                                            (Dias < 30) ? (vehiculo.Tarifario.find(w => w.Transmision.Id === idTransmision)?.PrecioSemana / Cambio) :
                                                (vehiculo.Tarifario.find(w => w.Transmision.Id === idTransmision)?.PrecioMes / Cambio)
                                    ).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} por día
                                </p>
                            </div>
                            {(vehiculo.Descuento > 0) &&
                                <>
                                <div>
                                    <strong>
                                        RESERVA CON {vehiculo.Descuento}% OFF
                                    </strong>
                                </div>
                                <div>
                                    <p style={{ "color": "#e30615" }}>
                                        {(vehiculo.Desde != null) &&
                                            <>                                 
                                            <br />
                                            <br />
                                            <br /> Desde {vehiculo.TxtDesde}</>
                                        }     
                                        {(vehiculo.Hasta != null) &&
                                        
                                            <><br />
                                            <br />
                                            <br />
                                            <br /> hasta {vehiculo.TxtHasta}</>
                                        }
                                    </p>
                                </div>
                            </>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <button type="button" className="btn  btn-medium" onClick={() => {

                                let { Id, Nombre, Tarifario, ImagenURL, EsLocal, Descuento, Modelo, Desde, Hasta, TxtDesde, TxtHasta, } = vehiculo;
                                let { Transmision, PrecioDia, PrecioSemana, PrecioMes } = Tarifario.find(w => w.IdTransmision === idTransmision)
                                let Precio = (Dias < 7) ? PrecioDia : (Dias < 30) ? PrecioSemana : PrecioMes


                                let selected = {
                                    Id,
                                    Nombre,
                                    Transmision,
                                    EsLocal,
                                    ImagenURL,
                                    Categoria: categoria,
                                    Precio,
                                    Descuento,
                                    Modelo,
                                    Desde,
                                    Hasta,
                                    TxtDesde,
                                    TxtHasta,
                                }

                                selectVehiculo(selected);

                                if (!coberturas.find(w => w.Seleccionado)) {
                                    checkObligatorio();
                                }

                                stepFoward();
                                window.scrollTo(0, 0);
                            }}>ESCOGER</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <hr />
                </div>
            </div>
        </>
    )
}


let mapDispatchToProps = dispatch => {
    return {
        stepFoward: () => dispatch(changeStepForm({ stepForm: STEPS.COBERTURAS })),
        checkObligatorio: () => dispatch(checkObligatorio()),
        selectVehiculo: value => dispatch(selectVehiculo(value))
    }
}

export default connect(null, mapDispatchToProps)(RowVehiculo);